import React from 'react';
import { parseNewLines as getMultiLineText } from '@alfa-bank/site-helpers-common/react/parse-new-lines';
import cn from 'classnames';

import type { TDesktop } from '../../models/desktop';
import type { TMobile } from '../../models/mobile';

/**
 * Функция отображения заголовка в основной версии баннера
 * @param props пропс виджета
 */
export function renderTitle(props: TDesktop | TMobile) {
    const { TextV2, styles, theme, title } = props;

    if (Array.isArray(title)) {
        const refactoredTitle = getMultiLineText(title, undefined, true);

        return (
            <TextV2
                className={cn(styles.external, styles.heading)}
                styler={{ marginTop: 0 }}
                tag="h1"
                theme={theme}
                view="large"
            >
                {refactoredTitle}
            </TextV2>
        );
    }

    return (
        <TextV2
            className={cn(styles.external, styles.heading, styles.headingTitle)}
            styler={{ marginTop: 0 }}
            tag="h1"
            theme={theme}
            view="large"
        >
            {title}
        </TextV2>
    );
}
